<template>
    <div class="modal-image" ref="container">
        <div class="modal-image__info" v-if="data.name || data.detail">
            <z-caption
                v-if="data.name"
                v-html="data.name"
                ref="name"
                class="modal-image__name"
                tag="h4"
                weight="600"
                size="xl"
            ></z-caption>
            <div
                ref="detail"
                v-html="data.detail"
                class="modal-image__detail"
            ></div>
        </div>

        <div
            :class="[
                'modal-image__img'
            ]"
        >
            <img
                ref="img"
                :alt="data.name"
                :src="data.link"
            >
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Object,
        offsetTop: {
            type: Number,
            default: 0
        },
        offsetBottom: {
            type: Number,
            default: 0
        },
        download: {
            type: Boolean,
            default: false
        },
    },
    data () {
        return {
            imgLoaded: false,
            maxHeight: 0
        }
    },
    computed: {
        parentOffset () {
            return this.offsetTop + this.offsetBottom
        },
    },
}
</script>

<style lang="scss">
    .modal-image {
        text-align: center;
        max-width: 100%;

        &__name,
        &__detail {
            text-align: left;
        }

        &__name {
            word-break: break-all;
            line-height: 1.2;
            color: var(--color-black);
            margin: 0 !important;
        }

        &__info {
            padding-right: 32px;
            margin-bottom: var(--spacer-xs);
        }

        &__detail {
            font-size: 13px;
            // @include typo-level(S);
            // @include margin-level(bottom, L);
            // line-height: 18px;
            // padding-top: 24px;
        }

        &__img {
            margin-bottom: var(--spacer-xs);

            img {
                max-width: 100%;
                margin: 0 auto;
            }
        }

        .z-preloader {
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
            width: 100%;
            min-width: 320px;
            height: 200px;
        }
    }
</style>
